import React, { useState } from 'react';
import { Input, Button, Form } from 'antd';
import axios from 'axios';
import { POST } from '../../utils/apis';
import { errorMessage, successMessage } from '../../utils/helpers';

const ContactForm = (props) => {
    const { selectedLanguage } = props
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)

    const onFinish = (values) => {
        setLoading(true)
        values.designName = 'clinic-design-1'
        axios.post(POST?.CREATE_CONTACT_FORM, values)
            .then((res) => {
                const { data } = res
                setLoading(false)
                form.resetFields()
                if (data?.success) {
                    successMessage(data?.message)
                } else {
                    errorMessage(data?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                form.resetFields()
                errorMessage(e?.message)
            })
    }
    
    return (
        <>
            <div className="main">
                <Form
                    name='form'
                    form={form}
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={true}
                >
                    <h3 className='form_heading'>{selectedLanguage?.txt_send_message}</h3>
                    <Form.Item
                        className='contact_form_input'
                        name="name"
                    >
                        <Input placeholder={selectedLanguage?.input_name_placeholder} />
                    </Form.Item>
                    <Form.Item
                        className='contact_form_input'
                        name="number"
                    >
                        <Input type="number" placeholder={selectedLanguage?.input_number_placeholder} />
                    </Form.Item>
                    <Form.Item
                        className='contact_form_input'
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: selectedLanguage?.txt_please_enter_your_email_message,
                            },
                            {
                                type: 'email',
                                message: selectedLanguage?.EmailIsNotValid,
                            },
                        ]}
                    >
                        <Input type="email" placeholder={selectedLanguage?.input_email_placeholder} />
                    </Form.Item>
                    <Form.Item
                        className='contact_form_input'
                        name="message"
                    >
                        <Input.TextArea style={{ maxHeight: 80 }} rows={4} placeholder={selectedLanguage?.input_message_placeholder} />
                    </Form.Item>
                    <Form.Item className='contact_form_input'>
                        <Button
                            type='primary'
                            className='contact_submit_btn'
                            htmlType='submit'
                            loading={loading}
                        >
                            {selectedLanguage?.submit_button}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    )
}
export default ContactForm